<template>
  <div>
    <v-btn
      class="mb-3"
      @click="downloadReport"
      color="primary"
      :loading="loading"
      >Download Report</v-btn
    >

    <router-view :id="id"></router-view>
    <snackbar
      :snackbar="showSnackbar"
      :snackbarText="snackbarText"
      @close="showSnackbar = false"
    ></snackbar>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import Objects from '@/services/Objects.js'
import Snackbar from '@/components/SnackbarMessage.vue'

export default {
  name: 'VesselTrial',
  props: {
    id: String
  },
  components: {
    Snackbar
  },
  data() {
    return {
      vesselTrial: '',
      showSnackbar: false,
      snackbarText: '',
      loading: false
    }
  },
  created() {
    this.getTrial()
  },
  methods: {
    getTrial() {
      ApiService.get(Objects.VesselTrial, this.id).then(response => {
        this.vesselTrial = response.data
        this.$store.dispatch('setPageTitle', this.vesselTrial.name)
        document.title = this.vesselTrial.name
      })
    },
    async downloadReport() {
      this.loading = true
      const file = await ApiService.getFile(this.id)
      if (file) {
        const url = window.URL.createObjectURL(
          new Blob([file.data], { type: file.extension })
        )
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `report.${file.extension}`) //or any other extension
        document.body.appendChild(link)
        link.click()
        this.loading = false
      } else {
        this.showSnackbar = true
        this.snackbarText = 'Please fill in all required fields'
      }
    }
  }
}
</script>

<style scoped></style>
